export const QUOTATION_STATUS_OPTIONS = {
    O: "Criada",
    P: "Preenchida",
    A: "Aceita",
    M: "Aceita parcial",
    R: "Recusada",
    C: "Cancelada",
  };

export const ORDER_STATUS_OPTIONS = {
    A: "Não confirmado",
    O: "Confirmado",
    P: "Pendente de entrega",
    E: "Encerrado",
    C: "Cancelado"
}

export const QUOTATION_STATUS_LIST = Object.entries(QUOTATION_STATUS_OPTIONS).map(([Id, Description]) => ({
    Id,
    Description
  }));


export const ORDER_STATUS_LIST = Object.entries(ORDER_STATUS_OPTIONS).map(([Id, Description]) => ({
    Id,
    Description
  }));